// Faithful port of eb-ui `packages/eds/eds-share-box/src/facebookUtils.js`
// (Facebook JS SDK lazy loader + FB.init/FB.ui wrappers).
import { HAS_WINDOW, getWindowObject } from '../../lib/featureDetection';

const FACEBOOK_JS_ID = 'facebook-jssdk';
const _getFacebookSdkUrl = (locale: string) =>
    `//connect.facebook.net/${locale}/sdk.js`;

// The FB SDK global is untyped (we don't pull @types/facebook-js-sdk for two
// method calls); shape kept to the two members eds-share-box used.
interface FacebookSdk {
    init: (options: object) => void;
    ui: (options: object) => void;
}

declare global {
    interface Window {
        fbAsyncInit?: () => void;
        FB?: FacebookSdk;
    }
}

/**
 * Load facebook-sdk and return a Promise that will be fulfilled
 * either when the script is loaded or when is already downloaded.
 */
export const getSdk = (locale: string): Promise<void> =>
    new Promise((resolve) => {
        // check if facebook-sdk is already loaded
        if (document.getElementById(FACEBOOK_JS_ID)) {
            resolve();
            return;
        }

        const firstScriptElement = document.getElementsByTagName('script')[0];
        const scriptElement = document.createElement('script');

        if (!firstScriptElement) return;

        if (HAS_WINDOW) {
            // facebook will call this function for us when the script has finish loading
            window.fbAsyncInit = () => resolve();
        }

        scriptElement.id = FACEBOOK_JS_ID;
        scriptElement.type = 'text/javascript';
        scriptElement.src = _getFacebookSdkUrl(locale);
        firstScriptElement.parentNode?.insertBefore(
            scriptElement,
            firstScriptElement,
        );
    });

export const initApplication = (options: object) =>
    getWindowObject('FB')?.init(options);

export const openUI = (options: object) => getWindowObject('FB')?.ui(options);
